import { render, staticRenderFns } from "./shopee.vue?vue&type=template&id=54768bc4&scoped=true&"
import script from "./shopee.vue?vue&type=script&lang=js&"
export * from "./shopee.vue?vue&type=script&lang=js&"
import style0 from "./shopee.vue?vue&type=style&index=0&id=54768bc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54768bc4",
  null
  
)

export default component.exports